import { Outlet } from "react-router-dom";

const AppShell = () => <Outlet />;

export default AppShell;
